import { useMediaQuery } from "@mui/material";
import React from "react";
import { BrandLogo, OnboardingBrandPanel, OnboardingStepper } from "../../components/onboarding/OnboardingBrand";
import { TwMainLayout } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import "../../styles/SignUp.css";
import SignUpForm from "./SignUpForm";

export default function SignUp({ navigation }) {
  const [userToken] = useLocalStorage("userToken");
  const [, setLoading] = React.useState(false);
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1023px)");
  const isMobile = useMediaQuery("(min-width: 280px) and (max-width: 767px)");

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="flex min-h-screen w-full bg-white">
        <OnboardingBrandPanel />

        <section className="flex flex-1 flex-col justify-center px-5 py-8 sm:px-10 md:px-16 xl:px-28">
          <BrandLogo variant="dark" className="mb-8 lg:hidden" />

          {!userToken && (
            <div className="w-full max-w-lg">
              <OnboardingStepper current={1} />
              <h1 className="mt-8 text-3xl sm:text-4xl font-black tracking-tight text-gray-900">Create your club account</h1>
              <p className="mt-2 text-base sm:text-lg text-gray-600">
                Join the community of smart, modern-day club management.
              </p>
              <div className="lg:hidden mt-4 inline-flex items-center gap-2 rounded-full bg-brown-coffee px-3 py-1 text-xs font-bold text-white">
                <span className="h-2 w-2 rounded-full bg-[#7CE0A3]" />30 days free · cancel anytime
              </div>

              <div className="mt-8">
                <SignUpForm navigation={navigation} isTablet={isTablet} isMobile={isMobile} setLoading={setLoading} />
              </div>

              <p className="mt-6 text-sm text-gray-600">
                Already have an account?{" "}
                <button type="button" className="font-extrabold text-indigo-bz hover:text-indigo-bz-hover" onClick={() => navigation("/")}>
                  Sign in
                </button>
              </p>
            </div>
          )}
        </section>
      </div>
    </TwMainLayout>
  );
}
